import { render, staticRenderFns } from "./WeekMenu.vue?vue&type=template&id=7129ef02&scoped=true&"
import script from "./WeekMenu.vue?vue&type=script&lang=js&"
export * from "./WeekMenu.vue?vue&type=script&lang=js&"
import style0 from "./WeekMenu.vue?vue&type=style&index=0&id=7129ef02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7129ef02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
installComponents(component, {VBtn,VBtnToggle})
